import { useEffect, useRef, useState } from 'react';

const useStickyBottom = () => {
  const [width, setWidth] = useState('100%');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      const container = containerRef.current;
      if (container) {
        setWidth(`${container.offsetWidth}px`);
      }
    };

    const handleClick = (event: MouseEvent) => {
      const menu = document.querySelector('[aria-label="menu"]');
      if (menu && menu.contains(event.target as Node)) {
        handleResize();
      }
    };

    handleResize();
    containerRef.current?.addEventListener('resize', handleResize);
    document.addEventListener('click', handleClick);
    return () => {
      containerRef.current?.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleClick);
    };
  }, [containerRef]);

  return {
    style: {
      position: 'sticky',
      bottom: 0,
      width,
    },
    containerRef,
  };
};

export default useStickyBottom;
